import axios from 'axios';
import { authHash } from '../lib/crypto';
import cookie from "js-cookie";
import { SET_LOADING } from './types';

export const authToken = async () => {
  const response = await axios.get(`${process.env.REACT_APP_GRAPH_API_URL}auth/token?hash=${authHash()}`);
  const token = await response.data.token;
  cookie.set("ap.token", token);
}

export const SetLoading = (value) => {
  return dispatch => dispatch({type:SET_LOADING, payload:value})
}





